import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { Caption } from 'atoms/typography';
import { rivals } from 'lib/glossary';

const Root = styled.div<{ isBlockchainCard: boolean }>`
  border-radius: var(--unit);
  padding: var(--half-unit);
  background-color: var(--c-brand-600);

  ${({ isBlockchainCard }) =>
    isBlockchainCard &&
    css`
      background-color: var(--c-score-high);
    `}
`;

type Props = { isBlockchainCard: boolean };

export const StartingStatus = ({ isBlockchainCard }: Props) => {
  return (
    <Root isBlockchainCard={isBlockchainCard}>
      <Caption
        bold
        color={isBlockchainCard ? 'var(--c-black)' : 'var(--c-white)'}
      >
        <FormattedMessage {...rivals.starting} />
      </Caption>
    </Root>
  );
};
